<template lang="pug">
  .pay-content
    .service-content-container
      .service-content__desc
        .content__desc__title {{ $t('企业节税解决方案') }}
        .content__desc {{ $t('企业对私付款，合法合规，分散风险，资金安全，智能高效。') }}
        .content__desc {{$t('300+家企业通过该服务，个税成本从45%降至8%。')}}
      .service-container__subTitle
        img(src="@/assets/icon-challenge.png")
        .subTitle {{ $t('企业面临的挑战与痛点') }}

      .service-challenge-container
        .challenge__item
          img(
            src="@/assets/service-icon5.png"
          )
          .item__title {{ $t('成本高昂') }}
          .item__desc {{ $t('企业公对私进行付款，无论是直接付给个人，还是通过走账公司支付给个人，均会产生高额成本，造成一定的财务负担。') }}
        .challenge__item
          img(
            src="@/assets/service-icon6.png"
          )
          .item__title {{ $t('合规性差') }}
          .item__desc {{ $t('个人无法提供发票，业务流、资金流、票据流、合同流四流不合一，企业内部流程不好操作，需高层管理者审批，既繁琐，又不合规。') }}
        .challenge__item
          img(
            src="@/assets/service-icon7.png"
          )
          .item__title {{ $t('效率低下') }}
          .item__desc {{ $t('支付给个人导致结算笔数较多，企业内部财务流程消耗较多的人力，精力及时间成本，而这些背后其实是另外一笔财务成本。') }}
      .service-container__subTitle
        img(src="@/assets/icon-project.png")
        .subTitle {{ $t('复歌的解决方案') }}

      .service-solution-container
        .solution-item
          img(
            src="@/assets/pay-item-1.png"
          )
          .solution-content
            .solution-content__title {{ $t('0风险降成本') }}
            .solution-content__desc {{ $t('轻轻付平台具有官方颁发的委托代征资质，可以合法合规给自由职业者结算费用，全国布局，有效降成本90%以上。只服务营销行业，确保100%真实场景，同时对甲方来说轻松实现四流（业务、资金、合同、票据）合一，安全高效。')}}
        .solution-item
          .solution-content
            .solution-content__title {{ $t('稳定高效') }}
            .solution-content__desc {{ $t('365*24小时，SaaS平台操作，稳定通畅。农行专用监管账户，资金随时可查。当天到账当天支付，钱不过夜。手机网签，批量支付，合并结算，省时高效。专业客服一对一服务，及时解决流程中遇到的任何问题。')}}
          img(
            src="@/assets/pay-item-2.png"
          )
        .solution-item
          img(
            src="@/assets/pay-item-3.png"
          )
          .solution-content
            .solution-content__title {{ $t('专家护航') }}
            .solution-content__desc {{ $t('专注服务于广告营销行业，并聘请专业律师团队进行风控审核，让企业和自由职业者用得放心。更有人资、银行、税务专家驻场，随时咨询。')}}
        .solution-item
          .solution-content
            .solution-content__title {{ $t('隐私保护') }}
            .solution-content__desc {{ $t('执行最高商用等级的隐私数据保护体系，确保个人自然信息和交易信息的完全脱敏与零泄露。')}}
          img(
            src="@/assets/pay-item-4.png"
          )
    CaseSample(
      :data="caseList"
    )
</template>

<script>
import CaseSample from '@/components/CaseSample'
export default {
  components: {
    CaseSample
  },
  data(){
    return {
      caseList: [
        {
          url: '/case/tax',
          img: require('@/assets/case-tax.jpg'),
          title: '享网互动',
          desc: '帮助享网互动解决了公对私付款时费用高、不合规的难题。'
        }
      ]
    }
  },
}
</script>
